import { render, staticRenderFns } from "./PopupLegajoDigital.vue?vue&type=template&id=38ae12c7&scoped=true&"
import script from "./PopupLegajoDigital.vue?vue&type=script&lang=js&"
export * from "./PopupLegajoDigital.vue?vue&type=script&lang=js&"
import style0 from "./PopupLegajoDigital.vue?vue&type=style&index=0&id=38ae12c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ae12c7",
  null
  
)

export default component.exports